import { ChevronDownIcon } from '@heroicons/react/24/outline';
import styled from 'styled-components';

import green_info_icon from '../../../../../../assets/green_info_2.svg';
import shield_icon from '../../../../../../assets/green_shield_2.svg';


interface IChevronContainerProps {
  isExpanded: boolean;
  children?: React.ReactNode;
}

interface IIconProps {
  src: string;
}

interface IPaymentInfoSectionProps {
  isExpandedPaymentSection: boolean;
  onExpandedPaymentSection: () => void;
}

interface IRootProps {
  onClick: () => void;
  children?: React.ReactNode;
}

const PaymentInfoSection: React.FC<IPaymentInfoSectionProps> = (props) => {
  const { isExpandedPaymentSection, onExpandedPaymentSection } = props;


  return (

    <>
      {isExpandedPaymentSection && (
        <InfoSection>
          <InfoRow>
            <Icon src={shield_icon} />
            <InfoDescription>EroPlay.ai won&apos;t access your payment data. Transactions are processed securely.</InfoDescription>
          </InfoRow>
          <InfoRow>
            <Icon src={shield_icon} />
            <InfoDescription>No hidden fees. Cancel anytime.</InfoDescription>
          </InfoRow>
          <InfoRow>
            <Icon src={green_info_icon} />
            <InfoDescription>Discreet billing: Payment appears as &ldquo;SIA ChatMist - Premium chat features&ldquo;</InfoDescription>
          </InfoRow>
        </InfoSection>
      )}
      <ExpanderSection onClick={onExpandedPaymentSection}>
        <PaymentInfoLabel>Payments info</PaymentInfoLabel>
        <ChevronContainer isExpanded={isExpandedPaymentSection} >
          <ChevronDownIcon className="h-4 w-4" />
        </ChevronContainer>
      </ExpanderSection>
    </>
  );
};

export default PaymentInfoSection;


const ExpanderSection = styled.div<IRootProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
`;

const InfoRow = styled.div`
  display: flex;
  gap: 12px;
`;

const InfoDescription = styled.span`
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #A9A9A9;
`;

const PaymentInfoLabel = styled.div`
  font-family: Nunito Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  color: #A9A9A9;
  font-family: Nunito Sans;
  font-size: 12px;
  font-weight: 400;
`;

const ChevronContainer = styled.div<IChevronContainerProps>`
  transform: ${({ isExpanded }) => isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.3s;
`;

const Icon = styled.img<IIconProps>`
  width: 14px;
  height: fit-content;
`;